import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { UerExportContractResultsQuery } from 'gql/graphql';
import { downloadURI } from 'utils/downloadDataURI';
import type { TActionCommonInterface } from 'utils/types';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { uerExportContractResultsGql } from '../../ContractQueries';

const requestId = 'uerExportContractResults';

export const useUerExportContractResults = (contractId: number) => {
    const dispatch = useDispatch();
    const [exportActKC3AsExcelMakeReset] = useResetStoreData({ requestId });

    const onSuccess = useCallback(
        (depsVars: TActionCommonInterface<UerExportContractResultsQuery>) => {
            exportActKC3AsExcelMakeReset(undefined);

            const { dataUrl, name } = depsVars?.payload?.uerExportContractResults?.data || {};

            if (dataUrl && name) {
                downloadURI(dataUrl, name);
            }
        },
        [exportActKC3AsExcelMakeReset],
    );

    const [, exportActKC3AsExcelStatus, , exportActKC3AsExcelRequest, , exportActKC3AsExcelAbort] =
        useRequest<UerExportContractResultsQuery>({
            requestId,
            query: uerExportContractResultsGql,
            withEffect: false,
            dependenciesUpdater: onSuccess,
        });

    const exportActKC3AsExcelMakeRequest = useCallback(() => {
        dispatch(exportActKC3AsExcelRequest({ contractId }));
    }, [contractId, dispatch, exportActKC3AsExcelRequest]);

    return {
        exportActKC3AsExcelAbort,
        exportActKC3AsExcelStatus,
        exportActKC3AsExcelMakeRequest,
    };
};
